import styled from "styled-components";
import {
  gridConfig,
  GridItem,
  GridRow,
  GridContainer,
} from "@tvg/fuse-responsive-grid";

export const StyledFirstSectionWrapper = GridItem;

export const StyledMiddleSection = styled(GridItem)`
  display: none;

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    display: grid;
  }
`;
export const StyledProductSectionWrapper = GridItem;

export const StyledGridRow = styled(GridRow)`
  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    && {
      row-gap: 0;
    }
  }
`;

export const StyledGridContainer = styled(GridContainer)`
  padding-bottom: 0;

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    && {
      padding-bottom: var(--spacing-space32);
    }
  }
`;
